import styled from "styled-components";
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

// 10px = 0.625rem
// 12px = 0.75rem
// 14px = 0.875rem
// 16px = 1rem (base)
// 18px = 1.125rem
// 20px = 1.25rem
// 24px = 1.5rem
// 30px = 1.875rem
// 32px = 2rem

export const H4 = styled.div`
  text-transform: uppercase;
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 1.25rem;
  color: #F8F8F8;
`;

export const P = styled.div`
  margin-bottom: 10px;
  font-size: 1rem;
  color: #F8F8F8;
`;

export const P2 = styled.div`
  margin-bottom: 10px;
  font-size: 0.875rem;
  color: #F8F8F8;
`;

export const StyledInput = styled.input`
  width: 100%;
  font-size: 14px;
  box-sizing: border-box;
  background: 0 0;
  border: 4px solid rgba(255,255,255,.2);
  border-radius: 5px;
  box-shadow: none;
  height: 42px;
  outline: medium none;
  padding: 6px 15px;
  transition: all .3s ease-in-out;
  color: #F8F8F8;
  margin-bottom: 10px;
  
  &:hover, &:focus {
    border-color: #f1e7c0;
  }
`;

export const StyledTextArea = styled.textarea`
  font-family: Montserrat, Roboto, "Helvetica Neue", Arial;
  width: 100%;
  font-size: 14px;
  box-sizing: border-box;
  background: 0 0;
  border: 4px solid rgba(255,255,255,.2);
  border-radius: 5px;
  box-shadow: none;
  outline: medium none;
  padding: 6px 15px;
  transition: all .3s ease-in-out;
  color: #F8F8F8;
  margin-bottom: 10px;
  
  &:hover, &:focus {
    border-color: #f1e7c0;
  }
`;

export const StyledSelect = styled.select`
  font-family: Montserrat, Roboto, "Helvetica Neue", Arial;
  width: 100%;
  font-size: 14px;
  box-sizing: border-box;
  background: 0 0;
  border: 4px solid rgba(255,255,255,.2);
  border-radius: 5px;
  box-shadow: none;
  height: 42px;
  outline: medium none;
  padding: 6px 10px;
  transition: all .3s ease-in-out;
  color: #F8F8F8;
  margin-bottom: 10px;
  
  &:hover, &:focus {
    border-color: #f1e7c0;
  }
  
  option {
    color: black;
  }
`;

const buttonStyles = {
  root: {
    width: '100%',
    height: 42,
    color: '#FFF',
    background: '#F62459',
    boxShadow: 'inset 0 -2px 0 rgba(0,0,0,.15)',
    '&:hover, &$focusVisible': {
      background: '#C93756'
    },
  },
};

export const StyledButton = withStyles(buttonStyles)(Button);

export const StyledError = styled.div`
  color: #f44336;
  margin: -2px 20px 10px;
  font-size: 0.75rem;
`;

export const InlineError = styled.div`
  color: #f44336;
  font-size: 0.75rem;
  margin-bottom: 10px; 
`
